import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var NothingFiltered = function NothingFiltered(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_jsxs("div", {
    className: "ptr-NothingFiltered",
    children: [/*#__PURE__*/_jsx("div", {
      className: "ptr-NothingFiltered-title",
      children: "Nothing filtered"
    }), /*#__PURE__*/_jsx("div", {
      className: "ptr-NothingFiltered-description",
      children: message || 'None of the datasets match filtering parameters'
    })]
  });
};

NothingFiltered.propTypes = {
  message: PropTypes.string
};
export default NothingFiltered;